import React from 'react';
import { ComponentInfo, CostSummary } from '@components';
import { useCostSummaryHelper } from './costSummary.helper';

export const CostSummaryPlaceholder: React.FC = () => {
	const { cost } = useCostSummaryHelper();

	return (
		<ComponentInfo name="CostSummaryPlaceholder">
			<CostSummary {...cost} />
		</ComponentInfo>
	);
};
